<template>
  <div>
    <div @mousemove="move" class="w3l-banner">
      <div
        :style="
          'transform: translate(' +
          (position == 'left' ? '20' : '-20') +
          'px,' +
          (position2 == 'top' ? '10' : '-10') +
          'px) scale(1.1)'
        "
        class="banner-image"
      ></div>
      <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
        <div
          class="wow flipInX titleT1"
          :class="contType == 'e' ? 'titleT1e' : ''"
        >
          {{ contList.title1[contType] }}
        </div>
        <div
          class="wow flipInX titleT2"
          :class="contType == 'e' ? 'titleT2e' : ''"
        >
          {{ contList.title2[contType] }}
        </div>
        <img
          class="wow bounceInDown titlebgIcon1"
          src="../assets/img/AboutUs/guang.svg"
          alt=""
        />
        <img
          class="wow bounceInDown titlebgIcon11"
          src="../assets/img/AboutUs/guang.png"
          alt=""
        />
        <img
          class="wow bounceInDown titlebgIcon2"
          src="../assets/img/AboutUs/map.png"
          alt=""
        />
        <img
          class="wow bounceInUp titlebgIcon3"
          src="../assets/img/AboutUs/jz.svg"
          alt=""
        />
        <img
          class="wow bounceInLeft titlebg"
          src="../assets/img/AboutUs/fj.svg"
          alt=""
        />
      </div>
    </div>

    <div class="twoSectionBoxStyle">
      <div class="twoSectionTitleBoxStyle">
        <div class="wow bounceInUp twoTitleT1Style">
          {{ contList.twoTitleT1[contType] }}
        </div>
        <div
          class="wow bounceInUp twoTitleT2Style"
          v-html="contList.twoTitleT2[contType]"
        ></div>
        <div
          class="wow bounceInUp twoTitleT3Style"
          v-html="contList.twoTitleT3[contType]"
        ></div>
      </div>

      <img
        class="wow bounceInUp twoImgT1Style"
        :src="images[contType][0]"
        alt=""
      />
    </div>

    <div class="bgBox">
      <div class="threeSectionBoxBg"></div>
    </div>
    <div class="contBox">
      <div class="threeSectionBoxStyle">
        <div class="threeSectionTitleBoxStyle">
          <div class="wow bounceInUp threeSectionTitleT1Style">
            {{ contList.threeTitleT1[contType] }}
          </div>
          <div class="wow bounceInUp threeSectionTitleT2Style">
            {{ contList.threeTitleT2[contType] }}
          </div>

          <div class="wow bounceInUp threeSectionTitleT1Style">
            {{ contList.threeTitleT3[contType] }}
          </div>
          <div class="wow bounceInUp threeSectionTitleT2Style">
            {{ contList.threeTitleT4[contType] }}
          </div>

          <div class="wow bounceInUp threeSectionTitleT1Style">
            {{ contList.threeTitleT5[contType] }}
          </div>
          <div class="wow bounceInUp threeSectionTitleT2Style">
            {{ contList.threeTitleT6[contType] }}
          </div>
        </div>

        <div class="threeSectionImgBoxStyle">
          <!--<div class="wow bounceInUp threeSectionLeftImgBoxStyle">
            <img
              class="threeSectionOneImtStyle"
              src="../assets/img/AboutUs/icon_msb_registration_00.png"
              alt=""
            />
            <div class="threeSectionOneTitleStyle">
              {{ contList.threeTitleT7[contType] }}
            </div>
          </div>-->

          <div class="wow bounceInUp threeSectionRightImgBoxStyle">
            <img
              class="threeSectionOneImtStyle"
              src="../assets/img/AboutUs/icon_mso_new_license_2022_00.png"
              alt=""
            />
            <div class="threeSectionOneTitleStyle">
              {{ contList.threeTitleT8[contType] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="contBox">
      <div class="fourSectionBgBoxStyle">
        <div class="fourSectionImgBoxStyle">
          <img
            class="wow bounceInUp fourSectionImgTopStyle"
            src="../assets/img/AboutUs/icon_four_top_2.png"
            alt=""
          />
          <img
            class="wow bounceInUp fourSectionImgBottomStyle"
            src="../assets/img/AboutUs/icon_four_bottom_2.png"
            alt=""
          />
        </div>

        <div class="fourSectionTitleBoxStyle">
          <div class="wow bounceInUp fourSectionTitleT1Style">
            {{ contList.fourTitleT1[contType] }}
          </div>
          <div class="wow bounceInUp fourSectionTitleT2Style">
            {{ contList.fourTitleT2[contType] }}
          </div>
          <div class="wow bounceInUp fourSectionTitleT2Style">
            {{ contList.fourTitleT3[contType] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <script src="https://smtpjs.com/v3/smtp.js"></script> -->
<script>
import { Email } from '../utils/smtp.js'
import { WOW } from 'wowjs'

export default {
  name: 'index',
  data: (vm) => {
    return {
      bodyW: 0,
      bodyY: 0,
      position: '',
      position2: '',
      contList: {
        title1: {
          z: '益索四方 共图大业',
          f: '益索四方 共圖大業',
          e: 'Suntone Everywhere,\nAchieving Together'
        },
        title2: {
          z: '致力于为跨境卖家提面向全球化、更贴近用户的收付款解决方案！',
          f: '致力於為跨境賣家提面向全球化、更貼近用戶的收付款解決方案！',
          e: "We're committed to providing cross-border sellers with \nglobal-oriented and user-friendly payment solutions!"
        },
        twoTitleT1: {
          z: '关于我们',
          f: '關於我們',
          e: 'SUNTONE GROUP'
        },
        twoTitleT2: {
          z: '      Suntone是一家独立的第三方跨境综合金融服务提供商，总部设于香港，公司创始人及主要管理团队成员均来自国际一线卡组织、金融机构和头部互联网行业，拥有多年的海内外金融机构及知名互联网企业的实战经验，专注于帮助中国卖家解决跨境收款难点、提升运营能力及财务管理效率，通过为合作商户定制“平台收款+多元化增值”组合方案，帮助商户在跨国经营中降低运营成本，创造更多收益。   ',
          f: '      Suntone（索圖） 是一家獨立的第三方跨境綜合金融服務提供商，總部設於香港，並在香港、美國及西班牙設立公司。<br/>公司創始人及核心管理團隊成員均來自國際一線卡組織、金融機構及頭部互聯網企業，擁有多年海內外支付、風控與跨境業務實戰經驗。我們專注於幫助商戶（尤其是拓展海外市場的中國賣家）解決跨境收款難題，提升運營效率與財務管理能力。<br/>通過為合作商戶量身定製「平台收款 + 多元化增值」組合方案，Suntone 協助商戶降低跨境經營成本、優化資金流轉，並創造更多收益。我們的服務涵蓋獨立站收單、跨境平台收款、多幣種帳戶及相關金融工具，支持電商、軟件遊戲、商旅、教育培訓等多個行業。',
          e: '      Suntone is an independent third-party cross-border comprehensive financial services provider, headquartered in Hong Kong, with companies established in Hong Kong, the United States, and Spain. <br/>Founded by professionals with extensive experience from leading international card schemes, financial institutions, and top-tier internet companies, our core team brings deep expertise in global payments, risk management, and cross-border operations. We specialize in helping merchants — particularly Chinese sellers expanding overseas — overcome the challenges of cross-border payment collection, improve operational efficiency, and enhance financial management. <br/>Through our tailored solutions combining platform collection + diversified value-added services, we enable merchants to reduce operating costs, optimize cash flow, and unlock greater profitability in international markets. Our services cover independent website acquiring, cross-border platform collections, multi-currency accounts, and related financial tools, supporting industries such as e-commerce, software & gaming, travel, education, and more. '
        },
        twoTitleT3: {
          z: '      索图在欧洲，亚洲等全球多个地区设立分支机构。我们接受美国、香港金融机构及海外国内银行的多方合规监管；严控反洗钱风险并制定了多重安全验证机制以保障用户的信息及资金安全；收款渠道稳定高效，技术服务更专业领先。作为连接商户、电商平台及合作银行的服务平台，我们致力于通过优质的产品、良好的信誉和贴心的服务，成为跨境电商卖家信赖的合作伙伴。',
          f: '      Suntone 接受多地金融監管，嚴格執行反洗錢（AML）風險控制，並建立多重安全驗證機制，確保用戶資訊與資金安全。我們的收款渠道穩定高效，技術服務專業領先，並與多家銀行及支付網絡保持緊密合作。<br/>作為連接商戶、電商平台與合作銀行的服務橋樑，Suntone 致力於以優質產品、良好信譽與貼心服務，成為跨境賣家值得信賴的合作夥伴，助力企業安全、高效地拓展國際市場。',
          e: '      We operate under multi-jurisdictional compliance supervision and maintain rigorous anti-money laundering (AML) controls and multi-layered security verification mechanisms to protect client information and funds. Our collection channels are stable and efficient, backed by professional technical capabilities and strong partnerships with banks and payment networks. <br/>As a trusted bridge connecting merchants, e-commerce platforms, and cooperative banks, Suntone is committed to delivering high-quality products, reliable service, and transparent operations — helping businesses expand globally with confidence.'
        },
        threeTitleT1: {
          z: '专业管理团队',
          f: '專業管理團隊',
          e: 'Professional Management Team'
        },
        threeTitleT2: {
          z: '多家全球500强企业精英及行业资深专家管理。',
          f: '多家全球500強企業精英及行業資深專家管理。',
          e: 'Management by elites and senior industrial experts from many global Top 500 Enterprises;'
        },
        threeTitleT3: {
          z: '支付更安全',
          f: '支付更安全',
          e: 'Safer Payment'
        },
        threeTitleT4: {
          z: '获得全球权威安全评估资质PCI认证，客户支付更放心。',
          f: '獲得全球權威安全評估資質PCI認證，客戶支付更放心。',
          e: "We've obtained the global authoritative security assessment qualification PCI certification, making customer payment more assured;"
        },
        threeTitleT5: {
          z: '全球化服务',
          f: '全球化服務',
          e: 'Global Services'
        },
        threeTitleT6: {
          z: '支持170+国家或地区支付服务，超过20种结算币种可选，与Visa、Master等\n全球知名金融机构深度合作。',
          f: '支持170+國家或地區支付服務，超過20種結算幣種可選，與Visa、Master等\n全球知名金融機構深度合作。',
          e: 'We support payment services in 170+ countries or regions, 20+ clearing currencies are available, and deeply cooperate with global well-known financial institutions such as Visa and MasterCard.'
        },
        threeTitleT7: {
          z: 'MSB牌照',
          f: 'MSB牌照',
          e: 'MSB licence'
        },
        threeTitleT8: {
          z: 'MSO牌照',
          f: 'MSO牌照',
          e: 'MSO licence'
        },
        fourTitleT1: {
          z: '选择我们',
          f: '選擇我們',
          e: 'Choose Us'
        },
        fourTitleT2: {
          z: '      SUNTONE不断优化生态布局，深入垂直细分领域，与多家知名金融机构及支付机构建立合作关系为SUNTONE提供强大的战略支撑，稳定的支付系统保障每一笔交易的安全，实时风控系统保证每一笔资金的合规。',
          f: '      SUNTONE不斷優化生態布局，深入垂直細分領域，與多家知名金融機構及支付機構建立合作關系為SUNTONE提供強大的戰略支撐，穩定的支付系統保障每一筆交易的安全，實時風控系統保證每一筆資金的合規。',
          e: '      Suntone continuously optimizes the ecological layout, digs into the vertical segments, and establishes a cooperative relationship with a number of well-known financial institutions and payment institutions to provide strong strategic support for Suntone. The stable payment system ensures the security of each transaction, and the real-time risk control system ensures the compliance of each tranche of fund.'
        },
        fourTitleT3: {
          z: '      支付更专业、操作更便捷、结算更高效是我们深受广大客户认可的根本，一流的技术团队及行业资深专家保障我们实时的前沿技术及研发能力，引领行业未来及科技。',
          f: '      支付更專業、操作更便捷、結算更高效是我們深受廣大客戶認可的根本，一流的技術團隊及行業資深專家保障我們實時的前沿技術及研發能力，引領行業未來及科技。',
          e: '      More professional payment, more convenient operation and more efficient clearing are the fundamentals of our recognition by our customers. First-class technical team and senior industrial experts ensure our real-time cutting-edge technology and R&D capabilities, leading the future and technology of the industry.'
        }
      },
      images: {
        z: [require('../assets/img/AboutUs/icon_map_511.png')],
        f: [require('../assets/img/AboutUs/icon_map_511.png')],
        e: [require('../assets/img/AboutUs/icon_map_511.png')]
      },
      contType: 'z'
    }
  },
  methods: {
    move(e) {
      if (e.pageX > this.bodyW / 2) {
        this.position = 'right'
      } else {
        this.position = 'left'
      }
      if (e.pageY > 250) {
        this.position2 = 'top'
      } else {
        this.position2 = 'bottom'
      }
    },
    changeTypeTitleName() {
      if (this.contType == 'f') {
        document.title = '關於我們'
      } else if (this.contType == 'e') {
        document.title = 'About Us'
      } else {
        document.title = '关于我们'
      }
    }
  },

  mounted() {
    this.bodyW = document.body.clientWidth
    this.bodyY = document.body.clientHeight
    var that = this
    this.contType = window.localStorage.getItem('language')
    that.changeTypeTitleName()
    window.addEventListener('setItemEvent', function (e) {
      if (e.key == 'language') {
        that.contType = e.newValue
        that.changeTypeTitleName()
      }
    })
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 40,
      mobile: true,
      live: true
    })
    wow.init()
    //QOFGPGRDUUMNZALE
  }
}
</script>

<style src="../assets/css/AboutUs-pc.css" scoped></style>
<style src="../assets/css/AboutUs-phone.css" scoped></style>

<!-- </style> -->
